// stores/itemStore.js
import { create } from "zustand";
import axios from "axios";
import authHeader from "../../services/auth-header";
import { APP_URL } from "../../services/http-common";
import useGlobalStore from "./globalStoreZs";

const URLEntityName = APP_URL + "graph";

const useGraphStore = create((set, get) => ({
  graphsZs: [],
  graphZs: {},
  totalPages: 0,
  totalElements: 0,
  size: 10, // default page size
  currentPage: 0,
  searchValueCurrent: "",
  year: 2024, // vitin që do të përdoret për filtrimin
  // Shtoni metodën për të vendosur vitin për filtrimin
  setYear: (year) => set({ year }),
  setYearAndFetch: (year) => {
    set({ year }); // Vendos vitin
    get().fetchGraphsZs(); // Kërkon të dhënat për vitin e vendosur
  },
  setSize: (size) => set({ size }),
  setCurrentPage: (page) => {
    set({ currentPage: page });
    get().fetchGraphsZs(); // refetch data
  },
  setSearchValueCurrent: (value) => {
    set({ searchValueCurrent: value, currentPage: 0 }); // reset page on search
    // get().fetchGraphsZs(); // refetch data
  },

  fetchGraphsZs: async () => {
    useGlobalStore.getState().setLoadingZs(true);
    set({ loading: true });

    const { size, currentPage, searchValueCurrent, year } = get();

    const params = {
      page: currentPage, // adjust for 0-based backend
      size,
    };

    // Shtoni vitin në parametrat e kërkesës, nëse është specifikuar
    if (year && searchValueCurrent.trim()) {
      // params.year = year;
      params.search = "year=" + year + "&title=" + searchValueCurrent.trim();
    } else {
      if (year && !searchValueCurrent.trim()) {
        params.search = "year=" + year;
      }
    }

    // if (searchValueCurrent.trim()) {
    //   const valueSearch = "title=" + searchValueCurrent.trim();
    //   params.title = searchValueCurrent.trim();
    // }

    try {
      const response = await axios.get(URLEntityName, {
        headers: authHeader(),
        params,
      });
      // set({ graphsZs: response.data });
      set({
        graphsZs: response.data?.content,
        totalPages: response.data.totalPages || 0,
        size: response.data.size,
        totalElements: response.data.totalElements || 0,
      });
    } catch (error) {
      console.error("Error fetching items", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },

  //   setFilterGraphsZs: () => {
  //   const { graphsZs, searchValueCurrent, currentPage, size } =
  //     get();
  //   const filtered = linesZs.filter((row) => {
  //     return Object.keys(row)
  //       .filter((key) => key !== "id") // Exclude 'id' from the search
  //       .some((key) => {
  //         const value = row[key];
  //         // Check if the value is a string and contains the search text
  //         return (
  //           typeof value === "string" &&
  //           value.toLowerCase().includes(searchTextLinesZs.toLowerCase())
  //         );
  //       });
  //   });
  //   const totalPages = Math.ceil(filtered.length / pageSizeLinesZs);

  //   // Ensure the current page does not exceed total pages
  //   // const currentPage = Math.min(currentPageLinesZs, totalPages - 1);

  //   // const start = currentPageLinesZs * pageSizeLinesZs;
  //   // const end = start + pageSizeLinesZs;

  //   set({
  //     // filterLinesZs: filtered.slice(start, end),
  //     totalPagesLinesZs: totalPages,
  //     currentPageLinesZs: currentPage,
  //     total: filtered.length,
  //   });
  // },

  getGraphZs: async (id) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.get(URLEntityName + "/" + id, {
        headers: authHeader(),
      });
      set({
        graphZs: response.data,
      });
    } catch (error) {
      console.error("Error fetching items", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },

  createGraphZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.post(URLEntityName, item, {
        headers: authHeader(),
      });

      //   await useGraphStore.getState().fetchGraphsZs();
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Rekordi u shtua me sukses!");
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  updateGraphZs: async (item) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.put(URLEntityName + "/" + item?.id, item, {
        headers: authHeader(),
      });

      //   await useGraphStore.getState().fetchGraphsZs();
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Grafiku u ndryshuar me sukses!");
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  deleteGraphZs: async (item) => {
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.delete(URLEntityName + "/" + item?.id, {
        headers: authHeader(),
      });
      await useGraphStore.getState().fetchGraphsZs();
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs("Grafiku u fshi me sukses!");
    } catch (error) {
      console.error("Error delete ", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },
}));

export default useGraphStore;
